// 적 스폰 시스템 통합 설정
const EnemySpawnConfig = {
  // 기본 스폰 설정
  SPAWN: {
    CAMERA_MARGIN: 5.0, // 카메라 밖 스폰 마진 거리
    MIN_SPAWN_DISTANCE: 10.0, // 플레이어로부터 최소 스폰 거리
    MAX_SPAWN_DISTANCE: 15.0, // 플레이어로부터 최대 스폰 거리
    MAX_ATTEMPTS: 20, // 안전한 스폰 위치 찾기 최대 시도 횟수
  },

  // 스폰 패턴별 설정
  PATTERNS: {
    // 뭉태기 스폰 설정
    CLUSTER: {
      SIZE_MIN: 3, // 최소 개수
      SIZE_MAX: 8, // 최대 개수
      RADIUS: 2.0, // 뭉태기 반경
    },
    // 보스 스폰 설정
    BOSS: {
      MIN_DISTANCE: 5.0, // 보스 간 최소 거리 (사용하지 않음, 보스 1마리만 생성)
      MIN_SPAWN_DISTANCE: 20.0, // 보스 최소 생성 거리 (플레이어 중심)
      SPACING_RADIUS: 25.0, // 보스 배치 최대 반경 (플레이어 중심)
    },
  },

  // 스테이지 시스템 설정
  STAGE: {
    // 스테이지별 난이도 증가율 (스테이지당 적용되는 증가율)
    SCALING_PER_STAGE: 4.0, // (1+SCALING_PER_STAGE)^stage

    // 각 웨이브 지속 시간
    BEGINNER_DURATION: 60, // 초급 웨이브: 1분
    INTERMEDIATE_DURATION: 60, // 중급 웨이브: 1분
    ADVANCED_DURATION: 60, // 고급 웨이브: 1분
    // 보스 웨이브: 보스가 죽을 때까지
  },

  // 웨이브 시스템 설정
  WAVES: {
    // 초급 웨이브 - 미니언만
    BEGINNER: {
      name: "초급 웨이브",
      spawns: [
        { interval: 3, pattern: "random", enemyType: "MINION" },
        { interval: 5, pattern: "cluster", enemyType: "MINION", args: [3] },
      ],
    },

    // 중급 웨이브 - 혼합
    INTERMEDIATE: {
      name: "중급 웨이브",
      spawns: [
        { interval: 3, pattern: "random", enemyType: "ROGUE" },
        { interval: 5, pattern: "cluster", enemyType: "ROGUE", args: [3] },
      ],
    },

    // 고급 웨이브 - 모든 적 타입
    ADVANCED: {
      name: "고급 웨이브",
      spawns: [
        { interval: 3, pattern: "random", enemyType: "MAGE" },
        { interval: 5, pattern: "cluster", enemyType: "MAGE", args: [3] },
      ],
    },

    // 보스 웨이브 - WARRIOR 보스 1마리 소환
    BOSS: {
      name: "보스 웨이브",
      spawns: [
        {
          interval: 0,
          pattern: "boss",
          enemyType: "WARRIOR",
        },
      ],
    },
  },

  // 스테이지 타임라인은 객체 초기화 후 별도로 설정됨
};

// 스테이지 타임라인 설정 (한 스테이지 = 초급 + 중급 + 고급 + 보스)
// 객체 초기화 후 설정하여 자기 참조 문제 해결
EnemySpawnConfig.STAGE_TIMELINE = [
  {
    startAt: 0,
    duration: EnemySpawnConfig.STAGE.BEGINNER_DURATION,
    wave: "BEGINNER",
  }, // 0~60초: 초급
  {
    startAt: EnemySpawnConfig.STAGE.BEGINNER_DURATION,
    duration: EnemySpawnConfig.STAGE.INTERMEDIATE_DURATION,
    wave: "INTERMEDIATE",
  }, // 60~120초: 중급
  {
    startAt:
      EnemySpawnConfig.STAGE.BEGINNER_DURATION +
      EnemySpawnConfig.STAGE.INTERMEDIATE_DURATION,
    duration: EnemySpawnConfig.STAGE.ADVANCED_DURATION,
    wave: "ADVANCED",
  }, // 120~180초: 고급
  {
    startAt:
      EnemySpawnConfig.STAGE.BEGINNER_DURATION +
      EnemySpawnConfig.STAGE.INTERMEDIATE_DURATION +
      EnemySpawnConfig.STAGE.ADVANCED_DURATION,
    duration: null,
    wave: "BOSS",
  }, // 180초~: 보스 (duration null = 보스 죽을 때까지)
  // { startAt: 0, duration: 10, wave: "BEGINNER" }, // 0~60초: 초급
  // { startAt: 10, duration: 10, wave: "INTERMEDIATE" }, // 60~120초: 중급
  // { startAt: 20, duration: 10, wave: "ADVANCED" }, // 120~180초: 고급
  // { startAt: 30, duration: null, wave: "BOSS" }, // 180초~: 보스 (duration null = 보스 죽을 때까지)
];

// 편의 함수들
EnemySpawnConfig.getWaveConfig = function (waveName) {
  return this.WAVES[waveName.toUpperCase()] || null;
};

EnemySpawnConfig.getPatternConfig = function (patternName) {
  return this.PATTERNS[patternName.toUpperCase()] || null;
};

// 웨이브 타임라인 반환
EnemySpawnConfig.getTimeline = function () {
  // 한국어 주석: TIMELINE은 제거되었고 STAGE_TIMELINE을 사용하지만, 하위 호환성을 위해 STAGE_TIMELINE 반환
  return this.STAGE_TIMELINE;
};

// 스테이지 타임라인 반환
EnemySpawnConfig.getStageTimeline = function () {
  return this.STAGE_TIMELINE;
};

// 스테이지별 스탯 배율 계산 (stage는 0부터 시작)
EnemySpawnConfig.getStageScaling = function (stage) {
  return Math.pow(1 + this.STAGE.SCALING_PER_STAGE, stage);
};

// webpack 빌드를 위해 default export 추가
export default EnemySpawnConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.EnemySpawnConfig = EnemySpawnConfig;
